/**
 * StyleX styles for admin releases components.
 */

import * as stylex from "@stylexjs/stylex";

import { colors, radius, space } from "@animus/primaris/tokens.stylex";

export const styles = stylex.create({
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: space.lg,
  },
  statusGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: space.md,
    marginBottom: space.lg,
  },
  statusCard: {
    borderRadius: radius.lg,
    borderWidth: 1,
    borderStyle: "solid",
    padding: space.md,
  },
  statusCardNormal: {
    borderColor: colors.border,
    backgroundColor: colors.card,
  },
  statusCardPinned: {
    borderColor: "rgba(234,179,8,0.3)",
    backgroundColor: "rgba(234,179,8,0.1)",
  },
  filterRow: {
    display: "flex",
    gap: space.sm,
    marginBottom: space.md,
  },
  filterButton: {
    borderRadius: radius.md,
    paddingInline: space.md,
    paddingBlock: space.xs,
    fontSize: 14,
    textTransform: "capitalize",
    cursor: "pointer",
    borderWidth: 0,
    borderStyle: "none",
  },
  filterActive: {
    backgroundColor: colors.primary,
    color: colors.primaryForeground,
  },
  filterInactive: {
    backgroundColor: colors.muted,
    color: colors.foregroundMuted,
    ":hover": {
      backgroundColor: colors.borderSubtle,
    },
  },
  loading: {
    paddingBlock: space["2xl"],
    textAlign: "center",
    color: colors.foregroundMuted,
  },
  tableWrapper: {
    overflow: "hidden",
    borderRadius: radius.lg,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
  },
  emptyState: {
    paddingBlock: space["2xl"],
    textAlign: "center",
    color: colors.foregroundSubtle,
  },
  unpinModal: {
    width: 448,
    maxWidth: "calc(100vw - 2rem)",
    borderRadius: radius.lg,
    backgroundColor: colors.card,
    padding: space.lg,
  },
  pinnedText: {
    marginBottom: space.xs,
    fontSize: 14,
    color: "#facc15",
  },
  // Release row styles
  badges: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  link: {
    fontFamily: "monospace",
    fontSize: 14,
    color: "#60a5fa",
    textDecoration: "none",
    ":hover": {
      textDecoration: "underline",
    },
  },
  mono: {
    fontFamily: "monospace",
    fontSize: 14,
  },
  maxWidth: {
    maxWidth: 300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  // Pin modal styles
  pinModalContainer: {
    width: "100%",
    maxWidth: 448,
    borderRadius: radius.lg,
    backgroundColor: colors.card,
    padding: space.lg,
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  },
  releaseInfo: {
    marginBottom: space.md,
    borderRadius: radius.md,
    backgroundColor: colors.muted,
    padding: space.md,
  },
  sha: {
    fontFamily: "monospace",
    fontSize: 14,
    color: "#60a5fa",
  },
  warningBox: {
    marginBottom: space.md,
    borderRadius: radius.md,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "rgba(249,115,22,0.3)",
    backgroundColor: "rgba(249,115,22,0.1)",
    padding: space.md,
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
    marginTop: space.sm,
  },
  input: {
    width: "100%",
    borderRadius: radius.md,
    backgroundColor: colors.muted,
    paddingInline: space.md,
    paddingBlock: space.sm,
    color: colors.foreground,
    fontSize: 14,
    borderWidth: 0,
    borderStyle: "none",
    ":focus": {
      outline: "2px solid",
      outlineColor: colors.ring,
    },
    "::placeholder": {
      color: colors.foregroundSubtle,
    },
  },
});
